import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import store from "./store";
import router from "./router";
import * as firebase from "firebase";
import Ionic from "@ionic/vue";
import "@ionic/core/css/ionic.bundle.css";
import { addIcons } from "ionicons";
import * as allIcons from "ionicons/icons";
import moment from "moment";
//import messaging from './messaging';
//@ts-ignore
import linkify from 'vue-linkify';
import { CombinedVueInstance } from 'vue/types/vue';

Vue.directive('linkified', linkify)

interface IconType {
  ios: string;
  md: string;
}

const currentIcons = (Object.keys(allIcons) as Array<
  keyof typeof allIcons
>).map(i => {
  return {
    ["ios-" + i]: (allIcons[i] as IconType).ios,
    ["md-" + i]: (allIcons[i] as IconType).md
  };
});
const iconsObject = Object.assign({}, ...currentIcons);
addIcons(iconsObject);

console.log(iconsObject);

// Required for side-effects
require("firebase/firestore");

Vue.use(Ionic);

//Filters
Vue.filter("formatDate", (value: string) => {
  if (value) {
    return moment(value).format("MM/DD/YYYY");
  }
});

Vue.config.productionTip = false;

let app:
  | CombinedVueInstance<
      Vue,
      object,
      object,
      object,
      Record<never, any>
    >
  | null = null;

const configOptions = {
  apiKey: "AIzaSyDhpeNhU10HYNwXxrfN72B81-H-8di2dGY",
  authDomain: "travelbuddies-ccb3c.firebaseapp.com",
  databaseURL: "https://travelbuddies-ccb3c.firebaseio.com",
  projectId: "travelbuddies-ccb3c",
  storageBucket: "travelbuddies-ccb3c.appspot.com",
  messagingSenderId: "110421571066",
  appId: "1:110421571066:web:0f1e1f7b9ccafbfe2ee043"
};

export const firebaseApp = firebase.initializeApp(configOptions);
export const db = firebaseApp.firestore();
if (location.hostname === "localhost") {
  // Note that the Firebase Web SDK must connect to the WebChannel port
  db.settings({
    host: "localhost:8088",
    ssl: false
  });
}


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
